/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import colors from "assets/theme/base/colors";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

export default {
  styleOverrides: {
    select: ({ theme }) => {
      const mode = theme.palette.mode || "light";
      const { transparent, text, background } = colors[mode];

      return {
        display: "flex",
        alignItems: "center",
        padding: `0 ${pxToRem(12)} !important`,
        backgroundColor: background.paper,
        color: text.primary,

        "& .Mui-selected": {
          backgroundColor: transparent.main,
        },

        // Remove any before/after pseudo-elements that might show odd characters
        "&::before": {
          content: "none !important",
          display: "none !important",
        },

        "&::after": {
          content: "none !important",
          display: "none !important",
        },
      };
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      display: "none",
    },
  },
};
